module.exports = require("swa-bootstrap-corporate-landing-home-page/api-cache-ttl");